var ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

function VideoCourseReceipt(params) {
  var self = this;
  self.texts = params.texts;
  self.API = params.api;
  self.sequenceKey = params.sequenceKey;
  self.hasRated = ko.observable(false);
  self.comment = ko.observable('');
  self.selectedItems = ko.observable(0);
  self.showError = ko.observable(false);
  self.ratingList = ko.observableArray([
    new RatingItem(1, 'ph ph-star icon', false),
    new RatingItem(2, 'ph ph-star icon', false),
    new RatingItem(3, 'ph ph-star icon', false),
    new RatingItem(4, 'ph ph-star icon', false),
    new RatingItem(5, 'ph ph-star icon', false),
    new RatingItem(6, 'ph ph-star icon', false)
  ]);
  self.updateRating = function(id) {
    ko.utils.arrayForEach(self.ratingList(), function(ratingItem) {
      ratingItem.isSelected(false);
      ratingItem.icon('ph ph-star icon');
    });

    var itemList = ko.utils.arrayFilter(self.ratingList(), function(item) {
      return item.id() <= id;
    });

    if (itemList) {
      itemList.forEach(function(item) {
        item.isSelected(true);
        item.icon('ph-fill ph-star icon selected');
      });
      self.selectedItems(itemList.length);
    }
    self.hasRated(
      itemList.some(function(item) {
        return item.isSelected();
      })
    );
  };
  self.postChanges = function() {
    var rateValue = ko.utils.arrayFilter(self.ratingList(), function(item) {
      return item.isSelected();
    }).length;
    APIHelper.post(
      '/api/videocourse/addrating',
      {
        ratingValue: rateValue,
        ratingComment: self.comment(),
        sequenceKey: self.sequenceKey
      },
      function(response) {
        if (response.IsSuccess) {
          window.location.reload();
          return;
        } else {
          self.showError(true);
        }
      },
      function(error) {
        console.log(error);
      }
    );
  };

  function RatingItem(id, icon, isSelected) {
    var self = this;
    self.id = ko.observable(id);
    self.icon = ko.observable(icon);
    self.isSelected = ko.observable(isSelected);
  }
}
module.exports = VideoCourseReceipt;
